import { useShellChrome } from 'lib/context/ShellContext/ShellContext';

// Shows a header-less table's header only while the page has shell actions for it. It reads the
// chrome itself, so another page part registering re-renders this gate, not the whole table.
const ChromeActionsGate = ({ children }) => {
  const chrome = useShellChrome();
  return chrome?.headerActions || chrome?.primaryAction ? children : null;
};

export default ChromeActionsGate;
